
import React from 'react';

const AuthLogo = () => {
  return (
    <div className="flex justify-center mb-6">
      <img 
        src="/lovable-uploads/EO-Sydney.svg" 
        alt="EO Sydney Logo" 
        className="h-16"
      />
    </div>
  );
};

export default AuthLogo;
